export default {
  search: 'Buscar',
  userAccessFor: 'Acesso de usuário para:',
  save: 'Salvar',
  warning: 'Aviso',
  cannotBeUndone: 'Esta ação não pode ser desfeita. Tem certeza?',
  abort: 'Cancelar',
  confirm: 'Confirmar',
  processing: 'Processando...',
  email: 'E-mail',
  name: 'Nome',
  users: 'Usuários'
}
